module.exports = __webpack_public_path__ + "static/media/img_gas_fee_support_s.63344e34.png";